<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
                    <c-form-item type="input" label="标题" name="name"></c-form-item>
                    <c-form-item type="checkbox" label="状态:" name="state" :options="states"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_faq_edit" @click="openAddDialog">新建问题</c-button>
			</m-operate>

            <c-table ref="table" code="faq">
                <c-table-column
                        label="标题"
                        name="name"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="发布时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="是否启用"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==2"><span style="color:darkgreen">启用</span></span>
                        <span v-if="data.state!=2"><span style="color:#999999">禁用</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortHandle"
                        width="120"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="170"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_faq_view" @click="openEditDialog(data)">查看</c-table-button>
                        <c-table-button power="b_faq_edit" v-if="data.state == 1"  @click="updateState(2,data)">启用</c-table-button>
                        <c-table-button power="b_faq_edit" v-if="data.state == 2"  @click="updateState(1,data)">禁用</c-table-button>
                        <c-table-button power="b_faq_edit" @click="openEditDialog(data)">编辑</c-table-button>
                        <c-table-button power="b_faq_edit" @click="deleteHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
		</module>

        <!-- 新增/编辑礼品卡任务弹框 -->
        <c-dialog
                ref="faqDialog"
                :title="faqDialogTitle"
                width="800px"
                @resolve="saveFaq"
        >
            <c-form ref="faqForm" label-width="100px" >
                <c-form-item label="常见问题：" type="input" name="name" word="请填写常见问题"  required></c-form-item>
                <c-form-item label="问题答案：" type="textarea" name="content" word="请填写答案"  required></c-form-item>
            </c-form>
        </c-dialog>


	</page>
</template>

<script>

    export default {
		name: 'm_faq',
        components: {},

		data() {
			return {
                states: [{
					name: '禁用',
					value: 1
				}, {
					name: '启用',
					value: 2
				}],
                isEdit: false,
                faqDialogTitle: '新增常见问题',
                faqId: '',
                detailTask: {
                    task_id:'',
                },
			}
		},

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

		computed: {
            defaultSearch() {
                return {};
            }
		},

		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
		},

		methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/faq/list',
                    data
                });
            },
            // 打开新增弹框
            openAddDialog() {
                this.isEdit = false;
                this.faqId = '';
                this.faqDialogTitle = '新增常见问题';
                this.$refs.faqForm.clear();
                this.$refs.faqDialog.open();
            },

            // 打开编辑弹框
            openEditDialog(faq) {
                this.isEdit = true;
                this.faqId = faq.id;
                this.faqDialogTitle = '编辑常见问题';
                this.$refs.faqForm.set({
                    name: faq.name,
                    content: faq.content,
                })
                this.$refs.faqDialog.open();
            },

            // 保存任务
            saveFaq(stop) {
                stop();
                this.$refs.faqForm.submit(
                    {
                        url: this.faqId ? '/faq/update' : '/faq/add',
                        // 校验规则
                        rule: {
                            name: [{  // 字段名
                                type: 'empty',  // 校验类型
                                word: '请填写问题'  // 提示文字
                            }],
                            content: [{  // 字段名
                                type: 'empty',  // 校验类型
                                word: '请填写问题解答'  // 提示文字
                            }],
                        },
                        dataFormatter: data => {
                            data.id = this.faqId;
                            return data;
                        },
                        success: () => {
                            this.$message({
                                text: '保存成功'
                            });
                            this.$refs.faqDialog.close();
                            this.$refs.search.search();
                        }
                });
            },

            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/faq/state',
                            data: {id:val.id,state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },

            deleteHandle(val) {
                this.$confirm({
                    text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/faq/del',
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
            sortHandle(row, type, next) {
                this.request({
                    url: '/faq/sort',
                    data: {
                        id: row.data.id,
                        parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
                        type: ['top', 'bottom'].includes(type) ? type : '',
                        id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                        id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                    },
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },
        }
	}
</script>

<style lang="stylus" scoped>.selected-agent, .selected-product {
    margin-top: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    max-width: 600px
}
</style>